/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Summary_LightInputs */

const en_ui_te_summary_light = /** @type {(inputs: Ui_Te_Summary_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light session — minimal overall training effect.`)
};

const de_ui_te_summary_light = /** @type {(inputs: Ui_Te_Summary_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leichte Einheit — minimaler Trainingseffekt.`)
};

/**
* | output |
* | --- |
* | "Light session — minimal overall training effect." |
*
* @param {Ui_Te_Summary_LightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_summary_light = /** @type {((inputs?: Ui_Te_Summary_LightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Summary_LightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_summary_light(inputs)
	return de_ui_te_summary_light(inputs)
});